/* eslint-disable react/prop-types */
import React from 'react';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import UserSvg from './UserSvg';
import UserNavigation from './UserNavigation';

const UserMenuDesktop = ({ className }) => {
  const { isLoggedIn } = checkIfLoggedIn();

  if (!isLoggedIn) return '';

  return (
    <li className={`${className} user-menu__user`}>
      <UserSvg />
      <UserNavigation className="user-menu__user-menu" subMenuClass="user-menu__menu-item" />
    </li>
  );
};

export default UserMenuDesktop;
